import React from 'react';
import { Box, Typography, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Chip, TextField } from '@mui/material';
import { styled } from '@mui/system';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// Estilo para los chips de filtro, usando el tema
const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.light, // Usar un color del tema
  color: theme.palette.secondary.contrastText,
  fontWeight: 'bold',
}));

function FilterPanel({ filters, onFilterChange, filterOptions, showOnly = [] }) {
  const shouldShow = (field) => showOnly.length === 0 || showOnly.includes(field);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3 }}>
        Filtros de Espacios
      </Typography>

      {/* Filtro por Código */}
      {shouldShow('codigo') && (
        <FormControl fullWidth sx={{ mb: 3 }}>
          <TextField 
            label="Buscar por Código" 
            variant="outlined"
            value={filters.codigo}
            onChange={(e) => onFilterChange('codigo', e.target.value)}
          />
        </FormControl>
      )}

      {/* Filtro por Tipo de Espacio */}
      {shouldShow('tipo_espacio') && (
        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="tipo-espacio-label">Tipo de Espacio</InputLabel>
          <Select
            labelId="tipo-espacio-label"
            id="tipo-espacio-select"
            multiple
            value={filters.tipo_espacio || []}
            onChange={(e) => onFilterChange('tipo_espacio', e.target.value)}
            input={<OutlinedInput id="select-multiple-chip-tipo-espacio" label="Tipo de Espacio" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <StyledChip
                    key={value}
                    label={value}
                    onMouseDown={(e) => e.stopPropagation()}
                    onDelete={() => onFilterChange('tipo_espacio', selected.filter(v => v !== value))}
                  />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {filterOptions.tipo_espacio?.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Filtro por Tamaño */}
      {shouldShow('tamano') && (
        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="tamano-label">Tamaño</InputLabel>
          <Select
            labelId="tamano-label"
            id="tamano-select"
            multiple
            value={filters.tamano || []}
            onChange={(e) => onFilterChange('tamano', e.target.value)}
            input={<OutlinedInput id="select-multiple-chip-tamano" label="Tamaño" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <StyledChip
                    key={value}
                    label={value}
                    onMouseDown={(e) => e.stopPropagation()}
                    onDelete={() => onFilterChange('tamano', selected.filter(v => v !== value))}
                  />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {filterOptions.tamano?.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Filtro por Zona */}
      {shouldShow('zona') && (
        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="zona-label">Zona</InputLabel>
          <Select
            labelId="zona-label"
            id="zona-select"
            multiple
            value={filters.zona || []}
            onChange={(e) => onFilterChange('zona', e.target.value)}
            input={<OutlinedInput id="select-multiple-chip-zona" label="Zona" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <StyledChip
                    key={value}
                    label={value}
                    onMouseDown={(e) => e.stopPropagation()}
                    onDelete={() => onFilterChange('zona', selected.filter(v => v !== value))}
                  />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {filterOptions.zona?.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Filtro por Provincia */}
      {shouldShow('provincia') && (
        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="provincia-label">Provincia</InputLabel>
          <Select
            labelId="provincia-label"
            id="provincia-select"
            multiple
            value={filters.provincia || []}
            onChange={(e) => onFilterChange('provincia', e.target.value)}
            input={<OutlinedInput id="select-multiple-chip-provincia" label="Provincia" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <StyledChip
                    key={value}
                    label={value}
                    onMouseDown={(e) => e.stopPropagation()}
                    onDelete={() => onFilterChange('provincia', selected.filter(v => v !== value))}
                  />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {filterOptions.provincia?.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Filtro por Estado */}
      {shouldShow('estado') && (
        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="estado-label">Estado</InputLabel>
          <Select
            labelId="estado-label"
            id="estado-select"
            multiple
            value={filters.estado || []}
            onChange={(e) => onFilterChange('estado', e.target.value)}
            input={<OutlinedInput id="select-multiple-chip-estado" label="Estado" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <StyledChip
                    key={value}
                    label={value}
                    onMouseDown={(e) => e.stopPropagation()}
                    onDelete={() => onFilterChange('estado', selected.filter(v => v !== value))}
                  />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {filterOptions.estado?.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Filtro por Precio Min y Max */}
      {shouldShow('precio') && (
        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          <TextField 
            label="Precio Min" 
            type="number"
            variant="outlined"
            size="small"
            value={filters.precio_min || ''}
            onChange={(e) => onFilterChange('precio_min', e.target.value)}
            sx={{ flex: 1 }}
          />
          <TextField 
            label="Precio Max" 
            type="number"
            variant="outlined"
            size="small"
            value={filters.precio_max || ''}
            onChange={(e) => onFilterChange('precio_max', e.target.value)}
            sx={{ flex: 1 }}
          />
        </Box>
      )}
    </Box>
  );
}

export default FilterPanel;